import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

const ADMIN_USER = "admin";
const ADMIN_PASS = "20021987";

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("pirogi_token");
    if (token === "admin_authenticated") {
      setAdmin({ username: ADMIN_USER });
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    console.log("🔵 Login попытка:", { username, password });
    console.log("Ожидаемые:", { ADMIN_USER, ADMIN_PASS });
    console.log("Совпадает username?", username === ADMIN_USER);
    console.log("Совпадает password?", password === ADMIN_PASS);

    if (username === ADMIN_USER && password === ADMIN_PASS) {
      console.log("✅ Логин успешен!");
      localStorage.setItem("pirogi_token", "admin_authenticated");
      setAdmin({ username: ADMIN_USER });
      return { username: ADMIN_USER };
    }
    console.log("❌ Логин неверный");
    throw new Error("Неверный логин или пароль");
  };

  const logout = () => {
    localStorage.removeItem("pirogi_token");
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
